const Cross = ({ className = '' }: { className?: string }) => {
  return (
    <svg
      className={className}
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.00222 15V0H8.98669V15H6.00222ZM0 8.98669V6.00222H15V8.98669H0Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default Cross
